import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=17edc0ed&scoped=true&lang=pug"
import script from "./AccordionItem.vue?vue&type=script&lang=ts"
export * from "./AccordionItem.vue?vue&type=script&lang=ts"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=17edc0ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17edc0ed",
  null
  
)

export default component.exports